"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/web.dom.iterable");require("core-js/modules/es6.number.constructor");
















































































var _user = require("@/utils/user");
var _vue = _interopRequireDefault(require("vue"));
var _vSelectpage = _interopRequireDefault(require("v-selectpage")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
_vue.default.use(_vSelectpage.default);var _default = { name: 'GroupSkill', props: { taskId: { type: Number }, flowId: { type: Number } }, data: function data() {return { tableData: [], taskPosData: [], // 列表数据
      groupList: ['A', 'B', 'C', 'E', 'F'], skillListData: [], delSkillS: [], lastData: '', addPos: false, title: '', delIndex: '', searchData: { page: 1, pageSize: 100, // 页码条数
        rows: 10 }, addData: { skillId: '', taskId: '', flowId: '', groups: '', isStay: '0', stayTime: '' }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'skillName', label: '技能名', isShow: true }], rules: { skillId: [{ required: true, message: '请选择技能', trigger: 'blur' }], groups: [{ required: true, message: '请选择分组', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this; // self.handleGetData(self.taskId, self.flowId)
    self.handleGetSkillData();}, methods: { /**
                                            handleGetData: function(taskId, flowId) {
                                              const self = this
                                              self.addData.taskId = Number(taskId)
                                              self.addData.flowId = Number(flowId)
                                              console.log(self.addData)
                                              const path = '/api/temi/robot/task/' + taskId + '/flow/' + flowId + '/taskSkill'
                                              self.getData(path, {}, function(res) {
                                                self.tableData = res
                                              })
                                            },*/handleGetData: function handleGetData(taskSkill) {var self = this;self.addData.taskId = taskSkill.taskId;self.addData.flowId = taskSkill.flowId;self.tableData = taskSkill.skills;self.addData.isStay = taskSkill.isStay;self.addData.stayTime = taskSkill.stayTime;}, handleGetSkillData: function handleGetSkillData() {var self = this;console.log('addData', self.addData);self.getData('/api/temi/robot/skillList', self.searchData, function (res) {self.skillListData = res;
        console.log('skillD', res);
      });
    },
    handleRowClick: function handleRowClick(row, column, event) {
      if (!row.paramList) {
        var paramsList = JSON.parse(row.params);
        row.paramList = paramsList;
      }
      this.$emit('handleGetParams', row);
    },
    handleSetMod: function handleSetMod(taskSkill) {
      var self = this;
      if (taskSkill && taskSkill.paramList.length > 0) {
        self.tableData.forEach(function (skill) {
          if (skill.skillId === taskSkill.skillId) {
            skill.paramList = taskSkill.paramList;
          }
        });
      }
    },
    checkPermission: _user.checkPermission,
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addPos = true;
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addPos'].resetFields();
      this.cleanData();
      this.addPos = false;
    },
    updateMenu: function updateMenu(pos) {// 修改操作
      this.title = '修改';
      var self = this;
      self.addPos = true;
      self.addData = {
        id: pos.id,
        name: pos.name,
        taskId: pos.taskId };

    },
    handleGetResult: function handleGetResult() {
      var self = this;
      var result = {
        'isStay': self.addData.isStay,
        'stayTime': self.addData.stayTime,
        'skills': self.tableData,
        'deleteSkillIds': self.delSkillS };


      return result;
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addPos.validate(function (valid) {
        if (valid) {
          var skill = self.skillListData.filter(function (val) {return val.id + '' === self.addData.skillId;});
          if (skill.length > 0) {
            var data = {
              'skillName': skill[0].name,
              'skillId': skill[0].id,
              'params': skill[0].params,
              'paramList': JSON.parse(skill[0].params),
              'taskId': self.addData.taskId,
              'flowId': self.addData.flowId };

            self.tableData.push(data);
          }
          self.onCencal();
          /**
                           const taskId = self.addData.taskId
                           const flowId = self.addData.flowId
                           const path = '/api/temi/robot/task/' + taskId + '/flow/' + flowId + '/taskSkill'
                           self.postData(path, self.addData, function(res) {
                             self.$message({
                               message: '添加成功!',
                               type: 'success'
                             })
                             self.onCencal()
                             self.handleGetData(taskId, flowId)
                           }) */
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(index, skillId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.tableData.splice(index, 1);
        self.delSkillS.push(skillId);
        self.$emit('handleClearParams');
        /* const path = '/api/temi/robot/task/' + self.addData.taskId + '/flow/' + self.addData.flowId + '/taskSkill/' + skillId
                                         self.delData(path, {}, function(res) {
                                           self.$message({
                                             message: '删除成功!',
                                             type: 'success'
                                           })
                                           self.$emit('handleClearParams')
                                           self.handleGetData(self.addData.taskId, self.addData.flowId)
                                         })*/
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.cleanData();
      this.addPos = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData.name = '';
    } } };exports.default = _default;